class ProcessModel {
	constructor(process) {
		const { procId, procName } = process;

		this.label = procName;
		this.value = procId;
	}
}

export default ProcessModel;
